// Day / Night theme controller.
//
// The app ships in Night (obsidian glass) mode by default. Chefs plating in
// a bright office can switch to Day (ivory glass) mode. The preference is
// stored in localStorage under `cs_theme` and applied via a
// `data-theme="light" | "dark"` attribute on <html>. All CSS is driven off
// that attribute in index.css so no React re-render is needed to swap.

const KEY = "cs_theme";

export function getTheme() {
  try {
    const stored = localStorage.getItem(KEY);
    if (stored === "light" || stored === "dark") return stored;
  } catch (e) {}
  return "dark";
}

export function applyTheme(theme) {
  const t = theme === "light" ? "light" : "dark";
  try {
    document.documentElement.setAttribute("data-theme", t);
    document.documentElement.style.colorScheme = t;
    localStorage.setItem(KEY, t);
  } catch (e) {}
  try {
    window.dispatchEvent(new CustomEvent("cs:theme-changed", { detail: t }));
  } catch (e) {}
  return t;
}

export function toggleTheme() {
  const next = getTheme() === "light" ? "dark" : "light";
  return applyTheme(next);
}

// Boot the theme early so there's no flash. Called from index.js before
// React mounts.
export function initTheme() {
  applyTheme(getTheme());
}
